import { render } from "./CancerTreatmentPatternInterventions.vue?vue&type=template&id=ad9309e6"
import script from "./CancerTreatmentPatternInterventions.vue?vue&type=script&lang=js"
export * from "./CancerTreatmentPatternInterventions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__